import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useToggleApLock } from '@/hooks/registration/useToggleApLock';
import BaseConfirmDrawer from '@/components/ui/BaseConfirmDrawer';

const ToggleApLockDrawer = () => {
    const { t } = useTranslation('common');
    const {
        state,
        checkState,
        confirmMessage,
        closeApLockDialog,
        confirmApLockChange,
        handleCheckChange,
        resetCheckState,
        title,
    } = useToggleApLock();

    return (
        <BaseConfirmDrawer
            open={state.dialogState.isApLockOpen}
            title={title}
            confirmText={t('OK')}
            cancelText={t('Cancel')}
            onConfirm={confirmApLockChange}
            onClose={closeApLockDialog}
            showCloseButton={false}
            onExited={resetCheckState}
        >
            <Box>
                <Typography
                    sx={{
                        color: '#374151',
                        fontSize: 15,
                        lineHeight: 1.6,
                    }}
                >
                    {confirmMessage}
                </Typography>

                {state.apLockInfo.isLock && (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            mt: 2,
                        }}
                    >
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkState.enableWakeUp}
                                    onChange={handleCheckChange('enableWakeUp')}
                                />
                            }
                            label={t('Enable wake up')}
                        />
                    </Box>
                )}
            </Box>
        </BaseConfirmDrawer>
    );
};

export default ToggleApLockDrawer;
